export default {
    //正式环境
    url: "http://matchapi.jianyuesports.com/",

    //testurl:"http://192.168.61.69:8003/",
    testurl:"http://localhost:5160/",
    //testurl:"http://matchapi.jianyuesports.com/",

    //获取当前基础链接
    getRequestBaseUrl() {
        if (location.href.indexOf('jianyuesports.com') > -1){
            return this.url + 'api/';
        }else{
            return this.testurl + 'api/';
        }
       
    },
    getDownloadBaseUrl(){
        if (location.href.indexOf('jianyuesports.com') > -1) {
            return this.url;
        } else {
            return this.testurl;
        }
    }
}